export default [
    {
        path: 'cadastro-domiciliar',
        component: () => import(
            '@/views/atencao-basica/cadastro-domiciliar/Index'
        ),
        redirect: 'cadastro-domiciliar/index',
        children: [
            {
                name: 'atencao-basica-cadastro-domiciliar',
                path: 'index',
                props: true,
                component: () => import(
                    '@/views/atencao-basica/cadastro-domiciliar/List'
                ),
            },
            {
                name: 'atencao-basica-cadastro-domiciliar-create',
                path: 'create',
                component: () => import(
                    '@/views/atencao-basica/cadastro-domiciliar/Form'
                ),
            },
            {
                name: 'atencao-basica-cadastro-domiciliar-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/atencao-basica/cadastro-domiciliar/Form'
                ),
            },
        ],
    },
]